<template>
  <v-container id="user-profile-view" fluid tag="section">
    <div id="hide">
      <v-card>
        <v-card-title>
          Biaya Lain - Lain
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="data"
          :options.sync="options"
          :server-items-length="totalData"
        >
          <template v-slot:item.tgl="{ item }">
            <div>
              {{ formatDate(item.tgl) }}
            </div>
          </template>
          <template v-slot:item.nominal="{ item }">
            <div>
              {{ formatCurrency(item.nominal) }}
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
            <div class="d-md-none my-5"></div>
            <v-icon @click="printReceipt(item)"> mdi-printer </v-icon>
            <v-icon @click="deleteItem(item)"> mdi-delete </v-icon>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <main class="report" v-if="receiptData.id" id="section-print">
      <div class="header">
        <div class="left">
          <h6>TANDA TERIMA</h6>
          <p>STRIPPING CONTAINER</p>
        </div>
        <div class="right">
          <p>{{ receiptData.id }}</p>
        </div>
      </div>
      <div class="content">
        <div class="line">
          <p>Tanggal</p>
          <p>{{ formatDate(receiptData.tgl) }}</p>
        </div>
        <div class="line">
          <p>Dikeluarkan Oleh</p>
          <p>{{ receiptData.acc.nama }}</p>
        </div>
        <div class="line">
          <p>Rp</p>
          <p>Rp{{ formatCurrency(Math.abs(receiptData.nominal)) }}</p>
        </div>
        <div class="line">
          <p>Keperluan</p>
          <p>{{ receiptData.keperluan }}</p>
        </div>
      </div>
      <div class="ttd">
        <div>
          <p>Diserahkan Kepada,</p>

          <p class="nama">{{ receiptData.oleh.nama }}</p>
        </div>
      </div>
    </main>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "ContainerView",
  data() {
    return {
      id: "",
      search: "",
      totalData: 0,
      data: [],
      loading: false,
      options: {},
      receiptData: {},
      headers: [
        { text: "Tanggal Nota", value: "tgl" },
        { text: "KV", value: "kv" },
        { text: "KC", value: "kc" },
        { text: "Keperluan", value: "keperluan" },
        { text: "Nominal", value: "nominal" },
        { text: "Oleh", value: "oleh.nama" },
        { text: "Acc", value: "acc.nama" },
        { text: "Actions", value: "actions", sortable: false, align: "center" }
      ]
    };
  },
  watch: {
    options: {
      handler() {
        this.fetchData();
      },
      deep: true
    },
    search() {
      this.fetchData();
    }
  },
  methods: {
    printReceipt(item) {
      this.receiptData = item;

      setTimeout(() => {
        window.print();
      }, 100);
    },
    async fetchData() {
      this.loading = true;

      await axios
        .get(`kas/biaya-lain`, {
          params: {
            type: "paginate",
            limit: this.options.itemsPerPage,
            page: this.options.page,
            sortBy: this.options.sortBy[0] ? this.options.sortBy[0] : null,
            sortDesc: this.options.sortDesc[0]
              ? this.options.sortDesc[0]
              : null,
            search: this.search
          }
        })
        .then(res => {
          this.data = res.data.data;
          this.totalData = res.data.total;

          this.loading = false;
        })
        .catch(err => {
          this.loading = false;

          alert(err.response.data.message);
        });
    },
    async deleteItem(item) {
      if (!confirm("Apakah anda yakin ingin menghapus data ini?")) return;

      this.loading = true;

      await axios
        .delete(`kas/biaya-lain/${item.id}`)
        .then(res => {
          this.loading = false;

          this.fetchData();
        })
        .catch(err => {
          this.loading = false;
          alert(err.response.data.message);
        });
    },
    formatCurrency(num) {
      return new Intl.NumberFormat("id-ID").format(num);
    },
    formatDate(date) {
      const newDate = new Date(date);

      return `${String(newDate.getDate()).padStart(2, "0")}-${String(
        newDate.getMonth() + 1
      ).padStart(2, "0")}-${newDate.getFullYear()}`;
    }
  },
  created() {
    this.fetchData();
  }
};
</script>
<style scoped>
@media print {
  #section-print {
    width: 80mm auto;
  }
}

@page {
  size: 80mm auto;
}

#section-print {
  display: none;
  font-size: 14px;
  width: 80mm;
  height: auto;
}

.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.header {
  font-size: 12px;
  display: flex;
  justify-content: space-between;
}

.left h6 {
  font-size: 12px;
  text-decoration: underline;
  margin: 0;
  padding: 0;
}

.right p {
  border: 1px solid black;
  padding: 3px 10px;
}

.line {
  display: flex;
  justify-content: space-between;
}

.ttd {
  margin-top: 1rem;
  display: flex;
  justify-content: end;
}

.ttd .nama {
  margin-top: 4rem;
}

@media print {
  #section-print {
    display: inline-block;
  }

  #hide {
    display: none;
  }
}
</style>
